import { __decorate } from "tslib";
import { LitElement, html, css, property, customElement, internalProperty } from 'lit-element';
import { baseStyles } from './styles';
let CdsGridRow = class CdsGridRow extends LitElement {
    constructor() {
        super(...arguments);
        this.select = false;
        this.row = null;
        this._cells = null;
    }
    static get styles() {
        return [baseStyles, css `
      :host {
        display: contents;
        --internal-border-top: var(--cds-alias-object-border-width-100) solid var(--cds-alias-object-border-color);
        content-visibility: auto;
        contain-intrinsic-size: var(--row-height, var(--cds-global-space-11));
      }
      
      tr {
        display: contents;
      }

      tr:hover ::slotted(cds-grid-cell),
      :host([select]) ::slotted(cds-grid-cell) {
        --background: var(--cds-alias-object-interaction-background-hover)
      }

      :host([draggable='true']) {
        -webkit-user-drag: element;
        user-select: none;
        display: grid !important;
        grid-template-columns: var(--grid-template-columns);
        grid-column: 1 / -1;
      }

      ::slotted(cds-grid-cell) {
        --border-top: var(--internal-border-top);
      }

      :host([cds-draggable*=target]) {
        --internal-border-top: var(--cds-alias-object-border-width-100) solid var(--cds-alias-status-alt-tint) !important;
      }
    `];
    }
    get tr() {
        return this.shadowRoot.querySelector('tr');
    }
    get cells() {
        if (this._cells === null) {
            this._cells = Array.from(this.querySelectorAll('cds-grid-cell'));
        }
        return this._cells;
    }
    render() {
        return html `
      <tr aria-rowindex=${this.row + 1} @slotchange=${this.updateCells}>
        ${true ? html `<slot></slot>` : ''}
      </tr>
    `;
    }
    firstUpdated(props) {
        var _a;
        super.firstUpdated(props);
        if (this.draggable) {
            this.tr.addEventListener('mousedown', () => this.setAttribute('cds-draggable', 'active'));
            (_a = this.querySelector('[drag-handle]')) === null || _a === void 0 ? void 0 : _a.addEventListener('keydown', (e) => {
                if (e.ctrlKey || e.metaKey && (e.code === 'ArrowUp' || e.code === 'ArrowDown')) {
                    const items = Array.from(e.currentTarget.closest('cds-grid').querySelectorAll('[draggable]'));
                    const fromIndex = items.findIndex(i => i === this);
                    const targetIndex = e.code === 'ArrowUp' ? Math.max(0, fromIndex - 1) : Math.min(items.length - 1, fromIndex + 2);
                    const target = items[targetIndex];
                    this.dispatchEvent(new CustomEvent('draggableChange', { detail: { from: this, target, type: 'keydown' }, bubbles: true }));
                }
            });
        }
    }
    updated(props) {
        super.updated(props);
        if (props.has('select') && props.get('select') !== undefined && props.get('select') !== this.select) {
            this.dispatchEvent(new CustomEvent('selectChange', { bubbles: true, detail: this.select }));
        }
    }
    updateCells() {
        this._cells = null;
        this.cells.forEach((c, i) => {
            c.row = this.row;
            c.col = i;
        });
    }
};
__decorate([
    property({ type: Boolean, reflect: true })
], CdsGridRow.prototype, "select", void 0);
__decorate([
    internalProperty()
], CdsGridRow.prototype, "row", void 0);
CdsGridRow = __decorate([
    customElement('cds-grid-row')
], CdsGridRow);
export { CdsGridRow };
//# sourceMappingURL=grid-row.element.js.map